import React, { useRef, useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../../../components/AdminComponents/SideNav";
import CaSideNav from "../../../../components/AdminComponents/CaSideNav";
import {
  //   capitalizeWords,
  //   formatDateWithSuffix,
  capitalizeWords,
  remainingViewportHeight,
} from "../../../../components/icons/ApplicationColor";
// import CommonTopDetails from "../../../../components/AdminComponents/CommonTopDetails";
import { CustomerTopLevel } from "../../../../components/AdminComponents/MenuItems";
import {
  Card,
  Typography,
  Divider,
  Menu,
  Tooltip,
  Form,
  Row,
  Col,
  Select,
  Input,
  Button,
  // Tag,
  //   DatePicker,
  message,
  Switch,
  Spin,
} from "antd";
import {
  FileTextOutlined,
  ReadOutlined,
  TeamOutlined,
  BranchesOutlined,
  SaveOutlined,
  BackwardOutlined,
  RetweetOutlined,
} from "@ant-design/icons";
// import "../courseStyles.css";

import axiosInstance from "../../../../api/Axios";
import {
  FormInput,
  CUSTOMER_NAME_FIELD,
  CUSTOMER_ID_FIELD,
} from "../../CAAdminCoursePages/courseForm";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import { useSelector } from "react-redux";
import { PatternFormat } from "react-number-format";
import CustomerRightAdd from "./CustomerRightAdd";
// import dayjs from "dayjs";
// const dateFormat = "MMM DD YYYY";
const { Title, Paragraph } = Typography;
const { Option } = Select;

const mapPurposeOption = (option) => {
  if (option === "Project") return "Projects";
  if (option === "Quorum Survey") return "Quorum survey";
  return option;
};

const CustomerAdd = ({ purposeOptions: propPurposeOptions }) => {
  const location = useLocation();
  const userInfo = useSelector((state) => state.user);
  const classification = useSelector(
    (state) => state.orgdeatil.customerClassification
  );
  const brokerName = useSelector((state) => state.orgdeatil.brokerName);
  const [relationshipOptions, setRelationshipOptions] = useState([]);
  const isCAAdmin = location.pathname.includes("ca-admin");
  const WrapperComponent = isCAAdmin ? CaSideNav : Sidebar;
  const wrapperProps = isCAAdmin ? CustomerTopLevel : CustomerTopLevel;
  const [activeView, setActiveView] = useState("summary");
  const [formValues, setFormValues] = useState({});
  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const history = useNavigate();
  const tooltip_title = "This menu will be available after saving the customer";
  const menuItems = [
    {
      key: "summary",
      label: (
        <div className="menu-vertical-item">
          <FileTextOutlined style={{ fontSize: "22px" }} />
          <div>Profile</div>
        </div>
      ),
      disabled: false,
    },
    isCAAdmin && {
      key: "department",
      disabled: true,
      label: (
        <div className="menu-vertical-item disabled">
          <Tooltip title={tooltip_title}>
            <span
              style={{
                pointerEvents: "auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <BranchesOutlined style={{ fontSize: "22px" }} />
              <div>Access</div>
            </span>
          </Tooltip>
        </div>
      ),
    },
    {
      key: "courses",
      disabled: true,
      label: (
        <div className="menu-vertical-item disabled">
          <Tooltip title={tooltip_title}>
            <span
              style={{
                pointerEvents: "auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <TeamOutlined style={{ fontSize: "22px" }} />

              <div>Users</div>
            </span>
          </Tooltip>
        </div>
      ),
    },
    isCAAdmin && {
      key: "users",
      disabled: true,
      label: (
        <div className="menu-vertical-item disabled">
          <Tooltip title={tooltip_title}>
            <span
              style={{
                pointerEvents: "auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <ReadOutlined style={{ fontSize: "22px" }} />
              <div>Events</div>
            </span>
          </Tooltip>
        </div>
      ),
    },
  ];
  const [form] = Form.useForm();
  const [uploadedFiles, setUploadedFiles] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const formRef = useRef();

  const [showNtee, setShowNtee] = useState(false);
  const [nteeCode, setNteeCode] = useState([]);
  const [nteeCoreCode, setNteeCoreCode] = useState([]);
  const [purposeOptions, setPurposeOptions] = useState(propPurposeOptions || []);
  const [projectsDisabled, setProjectsDisabled] = useState(true);

  const NteeCoreCode = React.useCallback(async (code) => {
    try {
      const res = await axiosInstance.get(`/nteecorecode/?search=${code}`);
      setNteeCoreCode(res.data);
    } catch (error) {
      console.error("Error fetching NTEE Core Code:", error);
    }
  }, []);

  React.useEffect(() => {
    const fetchNteeCode = async () => {
      try {
        const res = await axiosInstance.get("/nteecode/");
        setNteeCode(res.data);
      } catch (error) {
        console.error("Error fetching NTEE Code:", error);
      }
    };
    fetchNteeCode();
  }, []);

  const handleNteeCode = (value, option) => {
    const selectedNteeCode = option?.["data-ntee-code"];
    form.setFieldsValue({
      ntee_core_code: null,
    });
    NteeCoreCode(selectedNteeCode);
  };

  const handleClientTypeChange = (value) => {
    if (value === "non-profit") {
      setShowNtee(true);
    } else {
      setShowNtee(false);
    }
  };

  React.useEffect(() => {
    if (propPurposeOptions) {
      setPurposeOptions(propPurposeOptions);
      return;
    }
    const fetchPurposeOptions = async () => {
      try {
        const parentId = userInfo?.data?.organization?.id;
        if (parentId) {
          const res = await axiosInstance.get(
            `/customer/customerslist/?parent_key_id=${parentId}&page_size=1`
          );
          setPurposeOptions(res?.data?.customer_purpose_options || []);
        }
      } catch (error) {
        console.error("Error fetching purpose options:", error);
      }
    };
    fetchPurposeOptions();
  }, [userInfo?.data?.organization?.id, propPurposeOptions]);

  const fetchRelationships = async () => {
    try {
      const orgId = userInfo?.data?.organization?.id;
      if (orgId) {
        const res = await axiosInstance.get(
          `accountrelationshiplist/?page=1&page_size=15&organization=${orgId}`
        );
        console.log("Account Relationships:", res.data);
        setRelationshipOptions(res.data?.results || []);
      }
    } catch (error) {
      console.error("Error fetching relationships:", error);
    }
  };

  React.useEffect(() => {
    fetchRelationships();
  }, [userInfo?.data?.organization?.id]);


  const handleInsurerNameChange = (value) => {
    form.setFieldsValue({ insurer_id: value });
  };

  const handleInsurerIdChange = (value) => {
    form.setFieldsValue({ insurer_name: value });
  };

  const loadParentSubscriptions = async () => {
    try {
      const parentId = userInfo?.data?.organization?.id;
      if (parentId) {
        const res = await axiosInstance.get(
          `/customer/customersubscriptions/?organization_id=${parentId}`
        );
        const subsData = res?.data?.data || [];
        const applicationNames = subsData.map((sub) => sub.application_name).filter(Boolean);
        const uniqueApps = [...new Set(applicationNames)];
        const hasCompProject = uniqueApps.includes("Comp Project") || uniqueApps.includes("JA/MP");
        setProjectsDisabled(!hasCompProject);
      }
    } catch (err) {
      console.error("Error fetching parent subscriptions:", err);
      setProjectsDisabled(true);
    } finally {
      setInitialLoading(false);
    }
  };

  React.useEffect(() => {
    loadParentSubscriptions();
  }, [userInfo?.data?.organization?.id]);


  const CreateSuccessfull = (id, data) => {
    messageApi.open({
      type: "success",
      content: `${classification ? capitalizeWords(classification) : "Customer"} creation success.`,
      duration: 5,
    });
    console.log(id, data);
    setTimeout(() => {
      setTimeout(() => {
        history(
          isCAAdmin
            ? `/ca-admin/customers/edit/${id}`
            : `/customers/edit/${id}`
        );
      }, 2000);
    }, 2000);
  };

  const CreateFailed = () => {
    messageApi.open({
      type: "error",
      content: `${classification ? capitalizeWords(classification) : "Customer"} Creation failure`,
      duration: 5,
    });
  };

  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const handleSubmit = async (values) => {
    setLoading(true);
    const normalizedValues = Object.fromEntries(
      Object.entries(values).filter(
        ([key, value]) => value !== null && value !== undefined
      )
    );
    const { deactivate_on, due_date, description, insurer_name, insurer_id, ...rest } = normalizedValues;

    const finalValues = {
      ...rest,
      logo_url: uploadedFiles,
      parent_key: userInfo?.data?.organization?.id,
      account_relationship_id: insurer_name,
    };

    if (values.org_type !== "non-profit") {
      finalValues.ntee_code = null;
      finalValues.ntee_core_code = null;
      finalValues.tax_type = null;
    } else {
      finalValues.ntee_code = values.ntee_code || null;
      finalValues.ntee_core_code = values.ntee_core_code || null;
      finalValues.tax_type = values.tax_type || null;
    }

    console.log("Form submitted with values:", finalValues);
    try {
      const res = await axiosInstance.post(`customer/customers/`, finalValues, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      console.log(res, "customer-res");
      CreateSuccessfull(res?.data?.id, res);
    } catch (err) {
      CreateFailed();
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    form.resetFields();
    setSelectedCountry("");
    setSelectedState("");
    setShowNtee(false);
  };
  return (
    <WrapperComponent props={wrapperProps}>
      {contextHolder}
      <div
        style={{
          background: "#f4f4f4",
          width: "100%",
          height: remainingViewportHeight(10),
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          padding: "24px",
          overflowY: "auto",
          gap: "24px",
          marginTop: "50px",
        }}
      >
        <div style={{ flexBasis: "10%", height: "100%" }}>
          <Card
            bordered
            hoverable
            style={{
              height: "100%",
              borderRadius: "12px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
              display: "flex",
              flexDirection: "column",
              padding: "5px",
              background: "#F9FBFC",
            }}
            className="no-padding-no-margin"
          >
            <Title
              // level={}
              style={{
                fontSize: "15.5px",
                textAlign: "center",
                width: "100%",
                // display: "block",
                fontWeight: "600",
                letterSpacing: 0.5,
                color: "#333333",
                marginTop: "28.5px",
              }}
            >
              Add {classification ? capitalizeWords(classification) : "Customer"}
            </Title>

            <Divider />
            <div style={{ paddingInline: "5px" }}>
              <Menu
                className="modern-sidebar-menu"
                mode="inline"
                selectedKeys={[activeView]}
                onClick={({ key }) => setActiveView(key)}
                style={{
                  flex: 1,
                  overflowY: "auto",
                  borderRight: "none",
                  width: "100%",
                  background: "transparent",
                }}
                items={menuItems}
              />
            </div>
          </Card>
        </div>
        <div style={{ flexBasis: "70%", display: "flex" }}>
          <Card
            style={{
              width: "100%",

              marginBottom: "10px",
            }}
            hoverable
          >
            <Spin spinning={initialLoading}>
              <Title level={4}>
                {classification ? capitalizeWords(classification) : "Customer"}{" "}
                Creation
              </Title>
              <Paragraph type="secondary">
                Create and configure your new{" "}
                {classification ? capitalizeWords(classification) : "Customer"} with
                the details below
              </Paragraph>
              {!initialLoading && (
                <Form
                  layout="vertical"
                  onFinish={handleSubmit}
              name="complex-form"
              form={form}
              ref={formRef}
              onValuesChange={(_, allValues) => setFormValues(allValues)}
            >
              <Row gutter={16}>
                <FormInput
                  field={{
                    ...CUSTOMER_NAME_FIELD,
                    span: 12,
                    label: classification
                      ? `${capitalizeWords(classification)} Name`
                      : CUSTOMER_NAME_FIELD.label,
                    placeholder: classification
                      ? `Enter ${capitalizeWords(classification)} name`
                      : CUSTOMER_NAME_FIELD.placeholder,
                    rules: CUSTOMER_NAME_FIELD.rules.map((rule) => ({
                      ...rule,
                      message: classification
                        ? rule.message?.replace(
                          "Customer",
                          capitalizeWords(classification)
                        )
                        : rule.message,
                    })),
                  }}
                />
                <FormInput
                  field={{
                    ...CUSTOMER_ID_FIELD,
                    span: 12,
                    label: classification
                      ? `${capitalizeWords(classification)} ID`
                      : CUSTOMER_ID_FIELD.label,
                    placeholder: classification
                      ? `Enter ${capitalizeWords(classification)} ID`
                      : CUSTOMER_ID_FIELD.placeholder,
                    rules: CUSTOMER_ID_FIELD.rules.map((rule) => ({
                      ...rule,
                      message: classification
                        ? rule.message?.replace(
                          "Customer",
                          capitalizeWords(classification)
                        )
                        : rule.message,
                    })),
                  }}
                />
              </Row>

              {relationshipOptions.length > 0 && (
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item label={`${brokerName || "Insurer"} Name`} name="insurer_name">
                      <Select
                        placeholder={`Select ${brokerName || "Insurer"} Name`}
                        onChange={handleInsurerNameChange}
                      >
                        {relationshipOptions.map((opt) => (
                          <Option key={opt.id} value={opt.id}>
                            {opt.insurer_name || opt.account_name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label={`${brokerName || "Insurer"} ID`} name="insurer_id">
                      <Select
                        placeholder={`Select ${brokerName || "Insurer"} ID`}
                        onChange={handleInsurerIdChange}
                      >
                        {relationshipOptions.map((opt) => (
                          <Option key={opt.id} value={opt.id}>
                            {opt.insurer_id || opt.account_id}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              )}
              <Row gutter={20}>
                <Col span={8}>
                  <Form.Item label="Trainery Client ID">
                    <Form.Item name="trainery_client_id" noStyle>
                      <Input
                        className="my-form-input-antd-test"
                        placeholder="Auto populates"
                        disabled
                        style={{ background: "#f5f5f5" }}
                      />
                    </Form.Item>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="EIN/Tax ID">
                    <Form.Item
                      name="ein"
                      noStyle
                      rules={[
                        {
                          pattern: /^\d{2}-\d{7}$/,
                          message: "EIN format req xx-xxxxxxx",
                        },
                      ]}
                    >
                      <PatternFormat
                        format="##-#######"
                        className="my-form-input-antd-test"
                        style={{
                          paddingTop: "0.57rem",
                          paddingBottom: "0.57rem",
                          paddingLeft: "0.7rem",
                          borderRadius: "0.5rem",
                          border: "0.1rem solid gray",
                        }}
                        placeholder={" xx-xxxxxxx"}
                      />
                    </Form.Item>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label={`${classification ? capitalizeWords(classification) : "Customer"} Type`}
                    name="org_type"
                  >
                    <Select placeholder="Select Type" onChange={handleClientTypeChange}>
                      <Option value="non-profit">Non Profit</Option>
                      <Option value="profit">Profit</Option>
                      <Option value="Local Government">Local Government</Option>
                      <Option value="Individual">Individual</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              {showNtee && (
                <Row gutter={20}>
                  <Col span={8}>
                    <Form.Item
                      name="ntee_code"
                      label="NTEE Category"
                    >
                      <Select
                        showSearch
                        placeholder="Select Ntee category"
                        onChange={(value, option) =>
                          handleNteeCode(value, option)
                        }
                        filterOption={(inputValue, option) => {
                          try {
                            return option.children
                              .join("")
                              .toLowerCase()
                              .includes(inputValue.toLowerCase());
                          } catch (e) {
                            return true;
                          }
                        }}
                      >
                        {nteeCode?.map((option) => (
                          <Option
                            key={option.id}
                            value={option.id}
                            data-ntee-code={option.ntee_code}
                          >
                            <strong>{option?.ntee_code}</strong> :{" "}
                            {option?.description}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      name="ntee_core_code"
                      label="NTEE Core Code"
                    >
                      <Select
                        showSearch
                        placeholder="Select Ntee Core Code"
                        filterOption={(inputValue, option) => {
                          try {
                            return option.children
                              .join("")
                              .toLowerCase()
                              .includes(inputValue.toLowerCase());
                          } catch (e) {
                            return true;
                          }
                        }}
                      >
                        {nteeCoreCode?.map((option) => (
                          <Option key={option.id} value={option.id}>
                            <strong>{option?.ntee_core_code}</strong> :{" "}
                            {option?.description}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={8}>
                    <Form.Item
                      name="tax_type"
                      label="Tax Type"
                    >
                      <Select
                        placeholder="Select Tax Type"
                      >
                        <Option value="">None</Option>
                        <Option value="501(c)(3)">501(c)(3)</Option>
                        <Option value="501(c)(4)">501(c)(4)</Option>
                        <Option value="501(c)(5)">501(c)(5)</Option>
                        <Option value="501(c)(6)">501(c)(6)</Option>
                        <Option value="501(c)(7)">501(c)(7)</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              )}
              <Row gutter={16}>
                {projectsDisabled ? (
                  <>
                    <Col span={8}>
                      <Form.Item label="Industry" name="industry">
                        <Input
                          placeholder={`Enter ${classification ? capitalizeWords(classification) : "Customer"} Industry`}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item label="Enrollment Type" name="enrollment_type">
                        <Select placeholder="Select Enrollment Type">
                          <Option value="Organization">Organization</Option>
                          <Option value="Individual Instructor">
                            Individual Instructor
                          </Option>
                          <Option value="Training Company">Training Company</Option>
                          <Option value="Consultant Company">Consultant Company</Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item label="Relationship Type" name="customer_purpose">
                        <Select
                          mode="multiple"
                          placeholder="Select Relationship Type"
                        >
                          {purposeOptions?.map((option) => (
                            <Option key={option} value={mapPurposeOption(option)}>
                              {option}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item label="Address" name="address">
                        <Input
                          placeholder={`Enter ${classification ? classification.toLowerCase() : "customer"}'s address`}
                        />
                      </Form.Item>
                    </Col>
                  </>
                ) : (
                  <>
                    <Col span={8}>
                      <Form.Item label="Relationship Type" name="customer_purpose">
                        <Select
                          mode="multiple"
                          placeholder="Select Relationship Type"
                        >
                          {purposeOptions?.map((option) => (
                            <Option key={option} value={mapPurposeOption(option)}>
                              {option}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item label="Address" name="address">
                        <Input
                          placeholder={`Enter ${classification ? classification.toLowerCase() : "customer"}'s address`}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item label="Country">
                          <Input.Group compact>
                            <Form.Item name="country" noStyle>
                              <CountryDropdown
                                value={selectedCountry}
                                onChange={(val) => setSelectedCountry(val)}
                                className="my-form-input-antd-test"
                                style={{
                                  height: "3rem",
                                  border: "0.1rem solid gray",
                                }}
                              />
                            </Form.Item>
                          </Input.Group>
                        </Form.Item>
                    </Col>
                  </>
                )}
              </Row>

              <Row gutter={20}>
                <Col span={8}>
                  <Form.Item label="State">
                    <Input.Group compact>
                      <Form.Item name="state" noStyle>
                        <RegionDropdown
                          country={selectedCountry}
                          value={selectedState}
                          onChange={(val) => setSelectedState(val)}
                          className="my-form-input-antd-test"
                          style={{
                            height: "3rem",
                            border: "0.1rem solid gray",
                          }}
                        />
                      </Form.Item>
                    </Input.Group>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="City" name="city">
                    <Input placeholder="Enter City" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="zipcode"
                    label="ZIP/Postal Code"
                    rules={[
                      {
                        pattern:
                          selectedCountry === "United Kingdom"
                            ? /^[0-9a-zA-Z]*$/
                            : /^[0-9]*$/,
                        message:
                          selectedCountry === "United Kingdom"
                            ? "Please enter valid characters only"
                            : "Please enter numbers only",
                      },
                      {
                        min:
                          selectedCountry === "United States" ||
                            selectedCountry === "India" ||
                            selectedCountry === "United Kingdom" ||
                            selectedCountry === ""
                            ? 5
                            : undefined,
                        max:
                          selectedCountry === ""
                            ? 5
                            : selectedCountry === "United States"
                              ? 5
                              : selectedCountry === "India"
                                ? 6
                                : selectedCountry === "United Kingdom"
                                  ? 7
                                  : undefined,
                        message: "Invalid postal code",
                      },
                    ]}
                  >
                    <Input placeholder="zip code" />
                  </Form.Item>
                </Col>
              </Row>

              {projectsDisabled && (
                <Row gutter={20}>
                  <Col span={8}>
                    <Form.Item
                      name="zipcode"
                      label="ZIP/Postal Code"
                      rules={[
                        {
                          pattern:
                            selectedCountry === "United Kingdom"
                              ? /^[0-9a-zA-Z]*$/
                              : /^[0-9]*$/,
                          message:
                            selectedCountry === "United Kingdom"
                              ? "Please enter valid characters only"
                              : "Please enter numbers only",
                        },
                        {
                          min:
                            selectedCountry === "United States" ||
                              selectedCountry === "India" ||
                              selectedCountry === "United Kingdom" ||
                              selectedCountry === ""
                              ? 5
                              : undefined,
                          max:
                            selectedCountry === ""
                              ? 5
                              : selectedCountry === "United States"
                                ? 5
                                : selectedCountry === "India"
                                  ? 6
                                  : selectedCountry === "United Kingdom"
                                    ? 7
                                    : undefined,
                          message: "Invalid postal code",
                        },
                      ]}
                    >
                      <Input placeholder="zip code" />
                    </Form.Item>
                  </Col>
                  <Col span={16}>
                    <Form.Item
                      label="Portal Access"
                      name="access"
                      valuePropName="checked"
                    >
                      <Switch checkedChildren="Yes" unCheckedChildren="No" />
                    </Form.Item>
                  </Col>
                </Row>
              )}
{" "}
              {false && (
                <Row gutter={16}>
                  <Col span={24}>
                    <Form.Item
                      label={`${classification ? capitalizeWords(classification) : "Customer"} Description`}
                      name="description"
                    >
                      <Input.TextArea
                        rows={4}
                        placeholder="Enter description"
                      />
                    </Form.Item>
                  </Col>
                </Row>
              )}
              <div
                className="group-1-box"
                style={{
                  paddingTop: "0rem",
                  paddingLeft: "0px",
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "100%",
                }}
              >
                <div>
                  <div style={{ display: "inline-block" }}>
                    <Form.Item label=" " colon={false}>
                      <Button
                        type="text"
                        htmlType="button"
                        style={{
                          background: "#D3D3D3",
                        }}
                        onClick={() => {
                          history(
                            isCAAdmin
                              ? "/ca-admin/trainery-learn/bundles/listing"
                              : "/trainery-learn/courses/listing"
                          );
                        }}
                      >
                        <BackwardOutlined />
                        Back
                      </Button>
                    </Form.Item>
                  </div>

                  <div style={{ display: "inline-block", marginLeft: "16px" }}>
                    <Form.Item label=" " colon={false} shouldUpdate>
                      {() => (
                        <Button
                          type="primary"
                          htmlType="submit"
                          className="save-update-btn"
                          loading={loading}
                          disabled={
                            form.getFieldsError().some(({ errors }) => errors.length > 0)
                          }
                        >
                          Save & Continue
                          <SaveOutlined />
                        </Button>
                      )}
                    </Form.Item>
                  </div>
                  <div style={{ display: "inline-block", marginLeft: "16px" }}>
                    <Form.Item label=" " colon={false}>
                      <Button
                        type="text"
                        htmlType="button"
                        onClick={handleReset}
                        style={{
                          background: "#D3D3D3",
                        }}
                      >
                        Reset
                        <RetweetOutlined />
                      </Button>
                    </Form.Item>
                  </div>
                </div>
              </div>
                </Form>
              )}
            </Spin>
          </Card>
        </div>
        <div style={{ flexBasis: "20%", height: "100%", marginRight: "15px" }}>
          <CustomerRightAdd
            formData={formValues}
            setUploadedFiles={setUploadedFiles}
          />
        </div>
      </div>
    </WrapperComponent>
  );
};

export default CustomerAdd;
